up.compiler('[destroy-voucher-cashing]', (element) => {
  let button = element.querySelector('.form--destroy-voucher')
  let input = element.querySelector('input[name*="_destroy"]')

  function markForDestruction() {
    input.setAttribute('value', true)
    let form = element.closest('form')
    up.validate(form, { target: '.form--cashed-vouchers, .form--total-price' })
  }

  if (button) {
    button.addEventListener('click', markForDestruction)
  }
})
